type SessionExpiredCallback = () => void;

const listeners = new Set<SessionExpiredCallback>();
let isActive = false;

export function emitSessionExpired(): void {
  if (isActive) return;
  // If no modal is mounted (no listeners), skip poisoning isActive.
  // ProtectedRoute handles the redirect via the Whoami auth error directly.
  // Setting isActive here would cause the modal to fire spuriously the next
  // time SessionExpiredModal mounts (e.g. after SPA login → dashboard nav).
  if (listeners.size === 0) return;
  isActive = true;
  localStorage.clear();
  listeners.forEach((callback) => callback());
}

export function onSessionExpired(callback: SessionExpiredCallback): void {
  listeners.add(callback);
  if (isActive) {
    callback();
  }
}

export function offSessionExpired(callback: SessionExpiredCallback): void {
  listeners.delete(callback);
}

export function resetSessionExpired(): void {
  isActive = false;
}
